/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { ImageLinkComponentEditor } from "cms/components/components/image-link/edit";
import { ImageLinkComponentDisplay } from "cms/components/components/image-link/display";
import { getComponentZoneLayout } from "cms/components/components/component";

const ImageLinkComponent = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <ImageLinkComponentDisplay />,
        editComponent: <ImageLinkComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

ImageLinkComponent.displayName = "ImageLinkComponent";
export { ImageLinkComponent };
